import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const CASAVI_SETTINGS_UPDATE_RESOURCE = "casavi-settings" as const;
export const CASAVI_SETTINGS_UPDATE_API_PATH = `/v1/${CASAVI_SETTINGS_UPDATE_RESOURCE}` as const;

export type CasaviSettingsUpdateBody =
  paths[typeof CASAVI_SETTINGS_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type CasaviSettingsUpdateResponse =
  paths[typeof CASAVI_SETTINGS_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useCasaviSettingsUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CasaviSettingsUpdateResponse, Error, CasaviSettingsUpdateBody>({
    mutationFn: async (casaviSettings: CasaviSettingsUpdateBody) => {
      const response = await alphartisApiAxios.patch<CasaviSettingsUpdateResponse>(
        `/v1/${CASAVI_SETTINGS_UPDATE_RESOURCE}`,
        casaviSettings,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [CASAVI_SETTINGS_UPDATE_RESOURCE],
      });
    },
  });
};
